function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "CheckboxActive_svg__51_c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#148CFC"
})), React.createElement("filter", {
  id: "CheckboxActive_svg__49_a",
  width: "143.8%",
  height: "143.8%",
  x: "-21.9%",
  y: "-15.6%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0784313725 0 0 0 0 0.549019608 0 0 0 0 0.988235294 0 0 0 0.501038024 0"
})), React.createElement("rect", {
  id: "CheckboxActive_svg__50_b",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  rx: 4
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 1)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#CheckboxActive_svg__49_a)",
  xlinkHref: "#CheckboxActive_svg__50_b"
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 0.5,
  y: 0.5,
  fill: "url(#CheckboxActive_svg__51_c)",
  stroke: "#000",
  strokeLinejoin: "square",
  strokeOpacity: 0.051,
  rx: 4
}), React.createElement("path", {
  fill: "#FFF",
  d: "M12.59 2.93a.909.909 0 00-.104.117L6.33 11.221l-2.328-3c-.303-.403-.9-.502-1.335-.221a.876.876 0 00-.208 1.284l2.687 3.477c.457.607 1.358.754 2.012.33.138-.09.259-.201.356-.33l6.515-8.65a.876.876 0 00-.082-1.187 1.013 1.013 0 00-1.356.006z"
}));

var SvgCheckboxActive = function SvgCheckboxActive(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default SvgCheckboxActive;